import React from "react";

// Volume Icons - Smoother curves with YouTube-like minimalism
export const VolumeMutedIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-label="Mute volume"
    {...props}
  >
    <path d="M11 5L6 9H2v6h4l5 4V5z" />
    <path d="M18 6l-6 12" />
  </svg>
);

export const VolumeLowIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-label="Low volume"
    {...props}
  >
    <path d="M11 5L6 9H2v6h4l5 4V5z" />
    <path d="M15.5 12a3.5 3.5 0 0 0-1.5-2.87" />
  </svg>
);

export const VolumeMediumIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-label="Medium volume"
    {...props}
  >
    <path d="M11 5L6 9H2v6h4l5 4V5z" />
    <path d="M15.5 12a5 5 0 0 0-2.5-4.33" />
  </svg>
);

export const VolumeHighIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-label="High volume"
    {...props}
  >
    <path d="M11 5L6 9H2v6h4l5 4V5z" />
    <path d="M15.5 12a5 5 0 0 0-2.5-4.33" />
    <path d="M18.5 12a7.5 7.5 0 0 0-3.5-6.5" />
  </svg>
);

// Play/Pause Icons - Filled shapes for YouTube-like boldness
export const PlayIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-label="Play video"
    {...props}
  >
    <polygon points="5 3 19 12 5 21" fill="currentColor" />
  </svg>
);

export const PauseIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-label="Pause video"
    {...props}
  >
    <rect x="6" y="4" width="4" height="16" fill="currentColor" />
    <rect x="14" y="4" width="4" height="16" fill="currentColor" />
  </svg>
);

// Picture-in-Picture Icons - Clean and proportional like YouTube
export const PictureInPictureIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-label="Enter picture-in-picture mode"
    {...props}
  >
    <rect x="2" y="2" width="20" height="12" rx="2" />
    <rect x="14" y="6" width="8" height="6" rx="1" fill="currentColor" />
  </svg>
);

export const ExitPictureInPictureIcon = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-label="Exit picture-in-picture mode"
    {...props}
  >
    <rect x="2" y="2" width="20" height="12" rx="2" />
    <path d="M14 6l-4 4m0-4l4 4" />
  </svg>
);

// Forward/Backward Icons - Stroke-based for clarity, YouTube-inspired
export const ForwardIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-label="Fast forward"
    {...props}
  >
    <polygon points="7 4 15 12 7 20" />
    <polygon points="13 4 21 12 13 20" />
  </svg>
);

export const BackwardIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-label="Backward"
    {...props}
  >
    <polygon points="17 4 9 12 17 20" />
    <polygon points="11 4 3 12 11 20" />
  </svg>
);

// Replay Icon - YouTube-like circular arrow with clean loop
export const ReplayIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-label="Replay"
    {...props}
  >
    <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
    <path d="M21 3v5h-5" />
    <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" />
    <path d="M8 16H3v5" />
  </svg>
);

// Loading Icon - YouTube-like spinner with rotation animation
export const LoadingIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-label="Loading"
    className="video-player-2-loading-spinner-icon animate-spin"
    {...props}
  >
    <path d="M21 12a9 9 0 1 1-6.22-8.57" />
  </svg>
);

// Settings Icon - Simplified gear to match YouTube's clean style
export const SettingsIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-label="Settings"
    {...props}
  >
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09A1.65 1.65 0 0 0 19.4 15z" />
  </svg>
);

// Fullscreen Icons - Simplified arrows for YouTube-like clarity
export const FullscreenIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-label="Enter fullscreen"
    {...props}
  >
    <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3" />
  </svg>
);

export const ExitFullscreenIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-label="Exit fullscreen"
    {...props}
  >
    <path d="M5 16H8a2 2 0 0 0 2-2v-3m-7 0v3a2 2 0 0 0 2 2h3m10-7v3a2 2 0 0 1-2 2h-3m7 0h-3a2 2 0 0 1-2-2v-3" />
  </svg>
);

// Info/Help Icon - Clean info icon for help button
export const InfoIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-label="Help"
    {...props}
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M12 16v-4" />
    <path d="M12 8h.01" />
  </svg>
);
